import {useCallback, useContext, useEffect, useMemo, useState} from "react";
import {UserSession, UserSessionContext, UserSessionUpdateContext} from "./utils/UserSession";
import Main from "./Main";
import {ObjectUtil} from "zavadil-ts-common";
import {SpmRestClient, SpmRestClientContext} from "./client/SpmRestClient";
import {
	ChangePasswordDialog,
	ChangePasswordDialogContext,
	ChangePasswordDialogContextContent,
	ChangePasswordDialogProps,
	ConfirmDialog,
	ConfirmDialogContext,
	ConfirmDialogContextData,
	ConfirmDialogProps,
	LocalizationContext,
	UserAlertsWidget
} from "zavadil-react-common";
import {UserAlertsContext} from "./utils/UserAlerts";

export default function App() {
	const localization = useContext(LocalizationContext);
	const [session, setSession] = useState<UserSession | null>(null);
	const isInitialized = useMemo(() => ObjectUtil.notEmpty(session), [session]);
	const restClient = useMemo(() => new SpmRestClient(() => setSession(new UserSession(null))), []);
	const userAlerts = useContext(UserAlertsContext);
	const [showAlerts, setShowAlerts] = useState<boolean>();
	const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogProps>();
	const [changePasswordDialog, setChangePasswordDialog] = useState<ChangePasswordDialogProps>();

	const alertsChanged = useCallback(() => {
		setShowAlerts(userAlerts.alerts.length > 0);
	}, [userAlerts]);

	const confirmDialogContext = useMemo<ConfirmDialogContextData>(() => new ConfirmDialogContextData(setConfirmDialog), []);

	const changePasswordDialogContext = useMemo<ChangePasswordDialogContextContent>(() => {
		return {
			show: (props: ChangePasswordDialogProps) => setChangePasswordDialog(props),
			hide: () => setChangePasswordDialog(undefined),
		}
	}, []);

	useEffect(
		() => {
			localization.setLanguage('cs');
			userAlerts.addOnChangeHandler(alertsChanged);

			restClient
				.initialize()
				.then(
					() => {
						restClient.users
							.profile()
							.then((u) => setSession(new UserSession(u)))
							.catch(() => setSession(new UserSession(null)));
					}
				)
				.catch(() => setSession(new UserSession(null)));

			return () => {
				userAlerts.removeOnChangeHandler(alertsChanged);
			};
		},
		[]
	);

	return (
		<SpmRestClientContext.Provider value={restClient}>
			<UserSessionContext.Provider value={session}>
				<UserSessionUpdateContext.Provider value={setSession}>
					<ConfirmDialogContext.Provider value={confirmDialogContext}>
						<ChangePasswordDialogContext.Provider value={changePasswordDialogContext}>
							{
								isInitialized ? <Main/>
									: <div>Inicializace...</div>
							}
							{changePasswordDialog && <ChangePasswordDialog {...changePasswordDialog} />}
							{confirmDialog && <ConfirmDialog {...confirmDialog} />}
							{showAlerts && <UserAlertsWidget userAlerts={userAlerts}/>}
						</ChangePasswordDialogContext.Provider>
					</ConfirmDialogContext.Provider>
				</UserSessionUpdateContext.Provider>
			</UserSessionContext.Provider>
		</SpmRestClientContext.Provider>
	);
};

